module.exports = __webpack_public_path__ + "static/media/gr.f3b82f11.svg";